// "Get in touch with us!" closing band, shared by About, Home, Services, Maturity Roadmap and
// Security Baseline. Copy and action as in the legacy About page
// (views/about/Sections/NeuFooterSektion.vue).
import { CALENDLY_URL } from './routes';

export const GET_IN_TOUCH = {
  title: 'Get in touch with us!',
  actions: [{ label: 'Schedule a Meeting', href: CALENDLY_URL }],
};
